import { IconExclamationCircle } from '@tabler/icons-react';
import type { AiChange, TestRunExecutionOutput } from '~/types';
import ErrorHoverCard from './ErrorHoverCard';
import { useRouter } from 'next/router';
import { useProjectId } from '~/hooks/context/useProjectId';
import Link from 'next/link';

type Error = TestRunExecutionOutput['errors'][0];

export default function TestErrorQuickView({
  errors,
  aiChanges,
  runId,
}: {
  errors: Error[];
  aiChanges: AiChange[];
  runId: string;
}) {
  const router = useRouter();
  const projectId = useProjectId();

  if (errors?.length === 0) {
    return null;
  }

  return (
    <ErrorHoverCard
      errors={errors}
      aiChanges={aiChanges}
      runId={runId}
    >
      <Link
        className="flex flex-shrink-0 cursor-pointer items-center gap-1 rounded-md bg-red-500/20 px-2 py-1 text-xs font-medium transition-colors hover:bg-red-500/30 dark:text-white"
        href={{
          pathname: router.pathname,
          query: { ...router.query, testRunDrawer: runId },
        }}
        as={`/project/${projectId}/history/${router.query.runOrSuiteId}/run/${runId}`}
      >
        <IconExclamationCircle size={12} />
        Error{errors.length > 1 ? `s (${errors.length})` : ''}
      </Link>
    </ErrorHoverCard>
  );
}
